module.exports = __webpack_public_path__ + "tz.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/tz.svg
// module id = 859
// module chunks = 0